import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClypComponent } from './simple-icons-clyp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClypComponent ],
    exports:      [ SimpleIconsClypComponent ],
    bootstrap:    []
})
export class SimpleIconsClypModule {}
